/**
 * subscription-frequency.js
 * Pairs with snippets/subscription-frequency.liquid.
 *
 * Purely visual/UX + one bridging value: it never computes price or
 * discounts itself — the subscribe-card price/compare-price it displays is
 * a plain lookup into the server-rendered availability blob below (each
 * plan's `price`/`compareAtPrice` there is Shopify's own already-computed
 * selling_plan_allocation value, not a client-side calculation). The only
 * thing it writes to the real form is the value/disabled state of the
 * single hidden name="selling_plan" input, using the exact disabled+value
 * idiom already proven in assets/card-product-custom.js (see its
 * sellingPlanInput handling) — enabled + a real id = subscribe, disabled +
 * blank = one-time.
 *
 * Also reacts to Dawn's own PUB_SUB_EVENTS.variantChange so the whole
 * widget shows/hides per the doc's mixed-availability requirement (some
 * variants may have selling plans, others may not) and repopulates the
 * "Deliver every" select for the newly selected variant — using a small
 * server-rendered availability blob, not the variant JSON payload, since
 * that payload does not reliably carry selling_plan_allocations.
 */
(function () {
  function initSubscriptionFrequency(root) {
    var availabilityScript = root.querySelector('[data-subscription-frequency-availability]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    var frequencySelect = root.querySelector('[data-sf-frequency-select]');
    var radios = root.querySelectorAll('[data-sf-radio]');
    var priceEl = root.querySelector('[data-sf-price]');
    var priceCompareEl = root.querySelector('[data-sf-price-compare]');

    var data = null;
    if (availabilityScript) {
      try {
        data = JSON.parse(availabilityScript.textContent);
      } catch (e) {
        data = null;
      }
    }

    function currentPurchaseType() {
      var checked = root.querySelector('[data-sf-radio]:checked');
      return checked ? checked.value : 'subscribe';
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput) return;

      if (currentPurchaseType() === 'onetime') {
        sellingPlanInput.setAttribute('disabled', 'disabled');
        sellingPlanInput.value = '';
        return;
      }

      var planId = frequencySelect ? frequencySelect.value : sellingPlanInput.value;
      if (planId) {
        sellingPlanInput.removeAttribute('disabled');
        sellingPlanInput.value = planId;
      } else {
        sellingPlanInput.setAttribute('disabled', 'disabled');
        sellingPlanInput.value = '';
      }
    }

    // Lookup only — the price/compare-price shown here come straight from
    // the selected <option>'s own data attributes (Shopify's already-computed
    // selling_plan_allocation values, server-rendered), never derived here.
    function syncPrice() {
      var option = frequencySelect && frequencySelect.selectedOptions && frequencySelect.selectedOptions[0];

      if (priceEl) {
        var price = option ? option.dataset.price : '';
        priceEl.textContent = price || '';
        priceEl.hidden = !price;
      }

      if (priceCompareEl) {
        var comparePrice = option ? option.dataset.compareAtPrice : '';
        priceCompareEl.textContent = comparePrice || '';
        priceCompareEl.hidden = !comparePrice || comparePrice === (option && option.dataset.price);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', syncSellingPlanInput);
    });

    if (frequencySelect) {
      frequencySelect.addEventListener('change', function () {
        syncSellingPlanInput();
        syncPrice();
      });
    }

    function repopulateFrequencySelect(plans) {
      if (!frequencySelect) return;
      frequencySelect.innerHTML = '';
      (plans || []).forEach(function (plan) {
        var option = document.createElement('option');
        option.value = plan.id;
        option.textContent = plan.name;
        option.dataset.price = plan.price || '';
        option.dataset.priceCents = plan.priceCents || '';
        option.dataset.compareAtPrice = plan.compareAtPrice || '';
        frequencySelect.appendChild(option);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && data) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data.variant;
        var match = variant && data.variants.filter(function (v) {
          return String(v.id) === String(variant.id);
        })[0];

        if (!match || !match.hasPlans) {
          root.setAttribute('hidden', 'hidden');
          return;
        }

        root.removeAttribute('hidden');
        repopulateFrequencySelect(match.plans);
        syncSellingPlanInput();
        syncPrice();
      });
    }

    syncSellingPlanInput();
    syncPrice();
  }

  document.querySelectorAll('[data-subscription-frequency]').forEach(initSubscriptionFrequency);
})();
